import * as i0 from '@angular/core';
import { Injectable, EventEmitter, Component, Input, Output, NgModule } from '@angular/core';
import * as i3 from 'base-generate-forms-library';
import { BaseGenerateFormsLibraryService } from 'base-generate-forms-library';
import * as i1 from '@ngrx/store';
import * as i2 from 'ngx-toastr';
import * as i4 from 'step-status-update-payload-service';
import * as i5 from 'reference-library';
import * as i6 from '@angular/common';
import * as i7 from 'override-radio-button-library';
import { OverrideRadioButtonLibraryModule } from 'override-radio-button-library';
import * as i8 from 'overide-upload-forms-library';
import { OverideUploadFormsLibraryModule } from 'overide-upload-forms-library';
import * as i9 from 'primeng/button';
import { StepStatusUpdateComponentLibraryModule } from 'step-status-update-component-library';
import { PrimengLibraryModule } from 'primeng-library';
import { DigitalSignatureLibraryModule } from 'digital-signature-library';

class GenerateFormsLibraryService {
    constructor() { }
}
GenerateFormsLibraryService.ɵfac = function GenerateFormsLibraryService_Factory(t) { return new (t || GenerateFormsLibraryService)(); };
GenerateFormsLibraryService.ɵprov = i0.ɵɵdefineInjectable({ token: GenerateFormsLibraryService, factory: GenerateFormsLibraryService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GenerateFormsLibraryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

function GenerateFormsLibraryComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵelementStart(1, "h6");
    i0.ɵɵelementStart(2, "b");
    i0.ɵɵtext(3, "Application to Immigrant Petition for Alien Workers");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function GenerateFormsLibraryComponent_div_8_div_9_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 21);
    i0.ɵɵelementStart(1, "button", 22);
    i0.ɵɵlistener("click", function GenerateFormsLibraryComponent_div_8_div_9_div_3_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r17); const ctx_r16 = i0.ɵɵnextContext(3); return ctx_r16.viewGenerateDoc(ctx_r16.i129Src); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function GenerateFormsLibraryComponent_div_8_div_9_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 23);
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r15 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r15.i129LastDocDate ? "Generated On " + ctx_r15.i129LastDocDate : "", " ");
} }
function GenerateFormsLibraryComponent_div_8_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r19 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵelementStart(1, "div", 17);
    i0.ɵɵelementStart(2, "button", 18);
    i0.ɵɵlistener("click", function GenerateFormsLibraryComponent_div_8_div_9_Template_button_click_2_listener() { i0.ɵɵrestoreView(_r19); const ctx_r18 = i0.ɵɵnextContext(2); return ctx_r18.postGenerateDoc("I129"); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, GenerateFormsLibraryComponent_div_8_div_9_div_3_Template, 2, 0, "div", 19);
    i0.ɵɵtemplate(4, GenerateFormsLibraryComponent_div_8_div_9_div_4_Template, 3, 1, "div", 20);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", ctx_r13.disabledControls);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r13.generateFormI129 && ctx_r13.generateActive129);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r13.generateFormI129 && ctx_r13.generateActive129);
} }
function GenerateFormsLibraryComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r21 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵelementStart(1, "div", 10);
    i0.ɵɵelementStart(2, "label");
    i0.ɵɵelementStart(3, "b");
    i0.ɵɵtext(4, "Form I-129");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "p", 11);
    i0.ɵɵtext(6, "Would you like to use system generated form or upload your own form?");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "lib-override-radio-button-library", 12);
    i0.ɵɵlistener("generateUpload", function GenerateFormsLibraryComponent_div_8_Template_lib_override_radio_button_library_generateUpload_7_listener($event) { i0.ɵɵrestoreView(_r21); const ctx_r20 = i0.ɵɵnextContext(); return ctx_r20.getInfoBack($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelement(8, "div", 13);
    i0.ɵɵtemplate(9, GenerateFormsLibraryComponent_div_8_div_9_Template, 5, 3, "div", 14);
    i0.ɵɵelementStart(10, "div", 10);
    i0.ɵɵelementStart(11, "lib-overide-upload-forms-library", 15);
    i0.ɵɵlistener("uploadData", function GenerateFormsLibraryComponent_div_8_Template_lib_overide_upload_forms_library_uploadData_11_listener($event) { i0.ɵɵrestoreView(_r21); const ctx_r22 = i0.ɵɵnextContext(); return ctx_r22.getUploadedData($event); })("deleteData", function GenerateFormsLibraryComponent_div_8_Template_lib_overide_upload_forms_library_deleteData_11_listener($event) { i0.ɵɵrestoreView(_r21); const ctx_r23 = i0.ɵɵnextContext(); return ctx_r23.getDeletedData($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(7);
    i0.ɵɵproperty("primaryData", ctx_r1.primaryData)("fileName", "I129")("isGenerated", ctx_r1.generateFormI129);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.generateFormI129);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("uploadedFileName", ctx_r1.uploadedFileName129)("documentID", ctx_r1.documentId129)("fileSrc", ctx_r1.i129Src)("UploadingTime", ctx_r1.i129LastDocDate)("isUploaded", ctx_r1.uploadedFormI129)("isGenerated", ctx_r1.generateFormI129)("primaryData", ctx_r1.inputData)("formName", "I129");
} }
function GenerateFormsLibraryComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 24);
    i0.ɵɵelementStart(1, "h6");
    i0.ɵɵelementStart(2, "b");
    i0.ɵɵtext(3, "Premium Processing Service");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function GenerateFormsLibraryComponent_div_10_div_8_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r28 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 21);
    i0.ɵɵelementStart(1, "button", 22);
    i0.ɵɵlistener("click", function GenerateFormsLibraryComponent_div_10_div_8_div_3_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r28); const ctx_r27 = i0.ɵɵnextContext(3); return ctx_r27.viewGenerateDoc(ctx_r27.i907Src); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function GenerateFormsLibraryComponent_div_10_div_8_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 23);
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r26 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r26.i907lastDocDate ? "Generated On " + ctx_r26.i907lastDocDate : "", " ");
} }
function GenerateFormsLibraryComponent_div_10_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r30 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵelementStart(1, "div", 17);
    i0.ɵɵelementStart(2, "button", 18);
    i0.ɵɵlistener("click", function GenerateFormsLibraryComponent_div_10_div_8_Template_button_click_2_listener() { i0.ɵɵrestoreView(_r30); const ctx_r29 = i0.ɵɵnextContext(2); return ctx_r29.postGenerateDoc("I907"); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, GenerateFormsLibraryComponent_div_10_div_8_div_3_Template, 2, 0, "div", 19);
    i0.ɵɵtemplate(4, GenerateFormsLibraryComponent_div_10_div_8_div_4_Template, 3, 1, "div", 20);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r24 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", ctx_r24.disabledControls);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r24.generateFormI907 && ctx_r24.generateActive907);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r24.generateFormI907 && ctx_r24.generateActive907);
} }
function GenerateFormsLibraryComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    const _r32 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵelementStart(1, "div", 10);
    i0.ɵɵelementStart(2, "label");
    i0.ɵɵelementStart(3, "b");
    i0.ɵɵtext(4, "Form I-907");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "p", 11);
    i0.ɵɵtext(6, "Would you like to use system generated form or upload your own form?");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "lib-override-radio-button-library", 12);
    i0.ɵɵlistener("generateUpload", function GenerateFormsLibraryComponent_div_10_Template_lib_override_radio_button_library_generateUpload_7_listener($event) { i0.ɵɵrestoreView(_r32); const ctx_r31 = i0.ɵɵnextContext(); return ctx_r31.getInfoBack($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(8, GenerateFormsLibraryComponent_div_10_div_8_Template, 5, 3, "div", 14);
    i0.ɵɵelementStart(9, "div", 10);
    i0.ɵɵelementStart(10, "lib-overide-upload-forms-library", 15);
    i0.ɵɵlistener("uploadData", function GenerateFormsLibraryComponent_div_10_Template_lib_overide_upload_forms_library_uploadData_10_listener($event) { i0.ɵɵrestoreView(_r32); const ctx_r33 = i0.ɵɵnextContext(); return ctx_r33.getUploadedData($event); })("deleteData", function GenerateFormsLibraryComponent_div_10_Template_lib_overide_upload_forms_library_deleteData_10_listener($event) { i0.ɵɵrestoreView(_r32); const ctx_r34 = i0.ɵɵnextContext(); return ctx_r34.getDeletedData($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(7);
    i0.ɵɵproperty("primaryData", ctx_r3.primaryData)("fileName", "I907")("isGenerated", ctx_r3.generateFormI907);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.generateFormI907);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("uploadedFileName", ctx_r3.uploadedFileName907)("documentID", ctx_r3.documentId907)("fileSrc", ctx_r3.i907Src)("UploadingTime", ctx_r3.i907lastDocDate)("isUploaded", ctx_r3.uploadedFormI907)("isGenerated", ctx_r3.generateFormI907)("primaryData", ctx_r3.inputData)("formName", "I907");
} }
function GenerateFormsLibraryComponent_div_11_div_13_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r39 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 21);
    i0.ɵɵelementStart(1, "button", 22);
    i0.ɵɵlistener("click", function GenerateFormsLibraryComponent_div_11_div_13_div_3_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r39); const ctx_r38 = i0.ɵɵnextContext(3); return ctx_r38.viewGenerateDoc(ctx_r38.g28Src); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function GenerateFormsLibraryComponent_div_11_div_13_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 23);
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r37 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r37.g28lastDocDate ? "Generated On " + ctx_r37.g28lastDocDate : "", " ");
} }
function GenerateFormsLibraryComponent_div_11_div_13_Template(rf, ctx) { if (rf & 1) {
    const _r41 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵelementStart(1, "div", 17);
    i0.ɵɵelementStart(2, "button", 18);
    i0.ɵɵlistener("click", function GenerateFormsLibraryComponent_div_11_div_13_Template_button_click_2_listener() { i0.ɵɵrestoreView(_r41); const ctx_r40 = i0.ɵɵnextContext(2); return ctx_r40.postGenerateDoc("G28"); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, GenerateFormsLibraryComponent_div_11_div_13_div_3_Template, 2, 0, "div", 19);
    i0.ɵɵtemplate(4, GenerateFormsLibraryComponent_div_11_div_13_div_4_Template, 3, 1, "div", 20);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r35 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", ctx_r35.disabledControls);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r35.generateFormG28 && ctx_r35.generateActiveG28);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r35.generateFormG28 && ctx_r35.generateActiveG28);
} }
function GenerateFormsLibraryComponent_div_11_Template(rf, ctx) { if (rf & 1) {
    const _r43 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 24);
    i0.ɵɵelementStart(2, "h6");
    i0.ɵɵelementStart(3, "b");
    i0.ɵɵtext(4, "Notice of Entry of Appearance as Lawfirm or Accredited Representative");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 25);
    i0.ɵɵelementStart(6, "div", 10);
    i0.ɵɵelementStart(7, "label");
    i0.ɵɵelementStart(8, "b");
    i0.ɵɵtext(9, "Form G-28");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "p", 11);
    i0.ɵɵtext(11, "Would you like to use system generated form or upload your own form?");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "lib-override-radio-button-library", 12);
    i0.ɵɵlistener("generateUpload", function GenerateFormsLibraryComponent_div_11_Template_lib_override_radio_button_library_generateUpload_12_listener($event) { i0.ɵɵrestoreView(_r43); const ctx_r42 = i0.ɵɵnextContext(); return ctx_r42.getInfoBack($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(13, GenerateFormsLibraryComponent_div_11_div_13_Template, 5, 3, "div", 14);
    i0.ɵɵelementStart(14, "div", 10);
    i0.ɵɵelementStart(15, "lib-overide-upload-forms-library", 15);
    i0.ɵɵlistener("uploadData", function GenerateFormsLibraryComponent_div_11_Template_lib_overide_upload_forms_library_uploadData_15_listener($event) { i0.ɵɵrestoreView(_r43); const ctx_r44 = i0.ɵɵnextContext(); return ctx_r44.getUploadedData($event); })("deleteData", function GenerateFormsLibraryComponent_div_11_Template_lib_overide_upload_forms_library_deleteData_15_listener($event) { i0.ɵɵrestoreView(_r43); const ctx_r45 = i0.ɵɵnextContext(); return ctx_r45.getDeletedData($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(12);
    i0.ɵɵproperty("primaryData", ctx_r4.primaryData)("fileName", "G28")("isGenerated", ctx_r4.generateFormG28);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.generateFormG28);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("uploadedFileName", ctx_r4.uploadedFileNameG28)("documentID", ctx_r4.documentIdG28)("fileSrc", ctx_r4.g28Src)("UploadingTime", ctx_r4.g28lastDocDate)("isUploaded", ctx_r4.uploadedFormG28)("isGenerated", ctx_r4.generateFormG28)("primaryData", ctx_r4.inputData)("formName", "G28");
} }
function GenerateFormsLibraryComponent_div_12_button_11_Template(rf, ctx) { if (rf & 1) {
    const _r49 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 28);
    i0.ɵɵlistener("click", function GenerateFormsLibraryComponent_div_12_button_11_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r49); const ctx_r48 = i0.ɵɵnextContext(2); return ctx_r48.viewGenerateDoc(ctx_r48.gi140Src); });
    i0.ɵɵelementEnd();
} }
function GenerateFormsLibraryComponent_div_12_span_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r47 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r47.g140lastDocDate ? "Generated On " + ctx_r47.g140lastDocDate : "", " ");
} }
function GenerateFormsLibraryComponent_div_12_Template(rf, ctx) { if (rf & 1) {
    const _r51 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 24);
    i0.ɵɵelementStart(2, "h6", 11);
    i0.ɵɵtext(3, "G-1450");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 25);
    i0.ɵɵelementStart(5, "div", 17);
    i0.ɵɵelementStart(6, "label");
    i0.ɵɵtext(7, "Form G-1450");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 17);
    i0.ɵɵelementStart(9, "button", 26);
    i0.ɵɵlistener("click", function GenerateFormsLibraryComponent_div_12_Template_button_click_9_listener() { i0.ɵɵrestoreView(_r51); const ctx_r50 = i0.ɵɵnextContext(); return ctx_r50.postGenerateDoc("G1450"); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 21);
    i0.ɵɵtemplate(11, GenerateFormsLibraryComponent_div_12_button_11_Template, 1, 0, "button", 27);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "div", 23);
    i0.ɵɵtemplate(13, GenerateFormsLibraryComponent_div_12_span_13_Template, 2, 1, "span", 6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(9);
    i0.ɵɵproperty("disabled", ctx_r5.disabledControls);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r5.gi140Src);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r5.gi140Src);
} }
function GenerateFormsLibraryComponent_div_13_button_11_Template(rf, ctx) { if (rf & 1) {
    const _r55 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 28);
    i0.ɵɵlistener("click", function GenerateFormsLibraryComponent_div_13_button_11_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r55); const ctx_r54 = i0.ɵɵnextContext(2); return ctx_r54.viewGenerateDoc(ctx_r54.gi145Src); });
    i0.ɵɵelementEnd();
} }
function GenerateFormsLibraryComponent_div_13_span_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r53 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r53.gi145DocDate ? "Generated On " + ctx_r53.gi145DocDate : "", " ");
} }
function GenerateFormsLibraryComponent_div_13_Template(rf, ctx) { if (rf & 1) {
    const _r57 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 24);
    i0.ɵɵelementStart(2, "h6", 11);
    i0.ɵɵtext(3, "G-1145");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 25);
    i0.ɵɵelementStart(5, "div", 17);
    i0.ɵɵelementStart(6, "label");
    i0.ɵɵtext(7, "Form G-1145");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 17);
    i0.ɵɵelementStart(9, "button", 26);
    i0.ɵɵlistener("click", function GenerateFormsLibraryComponent_div_13_Template_button_click_9_listener() { i0.ɵɵrestoreView(_r57); const ctx_r56 = i0.ɵɵnextContext(); return ctx_r56.postGenerateDoc("G1145"); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 21);
    i0.ɵɵtemplate(11, GenerateFormsLibraryComponent_div_13_button_11_Template, 1, 0, "button", 27);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "div", 23);
    i0.ɵɵtemplate(13, GenerateFormsLibraryComponent_div_13_span_13_Template, 2, 1, "span", 6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵadvance(9);
    i0.ɵɵproperty("disabled", ctx_r6.disabledControls);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r6.gi145Src);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r6.gi145Src);
} }
function GenerateFormsLibraryComponent_div_14_div_14_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r62 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 21);
    i0.ɵɵelementStart(1, "button", 22);
    i0.ɵɵlistener("click", function GenerateFormsLibraryComponent_div_14_div_14_div_3_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r62); const ctx_r61 = i0.ɵɵnextContext(3); return ctx_r61.viewGenerateDoc(ctx_r61.i130Src); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function GenerateFormsLibraryComponent_div_14_div_14_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 23);
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r60 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r60.i130lastDocDate ? "Generated On " + ctx_r60.i130lastDocDate : "", " ");
} }
function GenerateFormsLibraryComponent_div_14_div_14_Template(rf, ctx) { if (rf & 1) {
    const _r64 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵelementStart(1, "div", 17);
    i0.ɵɵelementStart(2, "button", 18);
    i0.ɵɵlistener("click", function GenerateFormsLibraryComponent_div_14_div_14_Template_button_click_2_listener() { i0.ɵɵrestoreView(_r64); const ctx_r63 = i0.ɵɵnextContext(2); return ctx_r63.postGenerateDoc("I130"); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, GenerateFormsLibraryComponent_div_14_div_14_div_3_Template, 2, 0, "div", 19);
    i0.ɵɵtemplate(4, GenerateFormsLibraryComponent_div_14_div_14_div_4_Template, 3, 1, "div", 20);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r58 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", ctx_r58.disabledControls);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r58.generateFormI130 && ctx_r58.generateActive130);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r58.generateFormI130 && ctx_r58.generateActive130);
} }
function GenerateFormsLibraryComponent_div_14_Template(rf, ctx) { if (rf & 1) {
    const _r66 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 24);
    i0.ɵɵelementStart(2, "h6");
    i0.ɵɵelementStart(3, "b");
    i0.ɵɵtext(4, "Petition for Alien Relative");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 25);
    i0.ɵɵelementStart(6, "div", 10);
    i0.ɵɵelementStart(7, "label");
    i0.ɵɵelementStart(8, "b");
    i0.ɵɵtext(9, "Form I-130");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "p", 11);
    i0.ɵɵtext(11, "Would you like to use system generated form or upload your own form?");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "lib-override-radio-button-library", 12);
    i0.ɵɵlistener("generateUpload", function GenerateFormsLibraryComponent_div_14_Template_lib_override_radio_button_library_generateUpload_12_listener($event) { i0.ɵɵrestoreView(_r66); const ctx_r65 = i0.ɵɵnextContext(); return ctx_r65.getInfoBack($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelement(13, "div", 13);
    i0.ɵɵtemplate(14, GenerateFormsLibraryComponent_div_14_div_14_Template, 5, 3, "div", 14);
    i0.ɵɵelementStart(15, "div", 10);
    i0.ɵɵelementStart(16, "lib-overide-upload-forms-library", 15);
    i0.ɵɵlistener("uploadData", function GenerateFormsLibraryComponent_div_14_Template_lib_overide_upload_forms_library_uploadData_16_listener($event) { i0.ɵɵrestoreView(_r66); const ctx_r67 = i0.ɵɵnextContext(); return ctx_r67.getUploadedData($event); })("deleteData", function GenerateFormsLibraryComponent_div_14_Template_lib_overide_upload_forms_library_deleteData_16_listener($event) { i0.ɵɵrestoreView(_r66); const ctx_r68 = i0.ɵɵnextContext(); return ctx_r68.getDeletedData($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵadvance(12);
    i0.ɵɵproperty("primaryData", ctx_r7.primaryData)("fileName", "I130")("isGenerated", ctx_r7.generateFormI130);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r7.generateFormI130);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("uploadedFileName", ctx_r7.uploadedFileName130)("documentID", ctx_r7.documentId130)("fileSrc", ctx_r7.i130Src)("UploadingTime", ctx_r7.i130lastDocDate)("isUploaded", ctx_r7.uploadedFormI130)("isGenerated", ctx_r7.generateFormI130)("primaryData", ctx_r7.inputData)("formName", "I130");
} }
function GenerateFormsLibraryComponent_div_15_div_10_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r73 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 21);
    i0.ɵɵelementStart(1, "button", 22);
    i0.ɵɵlistener("click", function GenerateFormsLibraryComponent_div_15_div_10_div_3_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r73); const ctx_r72 = i0.ɵɵnextContext(3); return ctx_r72.viewGenerateDoc(ctx_r72.i130PrepSrc); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function GenerateFormsLibraryComponent_div_15_div_10_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 23);
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r71 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r71.i130PREPlastDocDate ? "Generated On " + ctx_r71.i130PREPlastDocDate : "", " ");
} }
function GenerateFormsLibraryComponent_div_15_div_10_Template(rf, ctx) { if (rf & 1) {
    const _r75 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 31);
    i0.ɵɵelementStart(1, "div", 17);
    i0.ɵɵelementStart(2, "button", 18);
    i0.ɵɵlistener("click", function GenerateFormsLibraryComponent_div_15_div_10_Template_button_click_2_listener() { i0.ɵɵrestoreView(_r75); const ctx_r74 = i0.ɵɵnextContext(2); return ctx_r74.postGenerateDoc("I130PREP"); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, GenerateFormsLibraryComponent_div_15_div_10_div_3_Template, 2, 0, "div", 19);
    i0.ɵɵtemplate(4, GenerateFormsLibraryComponent_div_15_div_10_div_4_Template, 3, 1, "div", 20);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r69 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", ctx_r69.disabledControls);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r69.generateFormI130Prep && ctx_r69.generateActiveI130Prep);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r69.generateFormI130Prep && ctx_r69.generateActiveI130Prep);
} }
function GenerateFormsLibraryComponent_div_15_Template(rf, ctx) { if (rf & 1) {
    const _r77 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 29);
    i0.ɵɵelementStart(2, "div", 10);
    i0.ɵɵelementStart(3, "label");
    i0.ɵɵelementStart(4, "b");
    i0.ɵɵtext(5, "Form I-130 Preparer");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "p", 11);
    i0.ɵɵtext(7, "Would you like to use system generated form or upload your own form?");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "lib-override-radio-button-library", 12);
    i0.ɵɵlistener("generateUpload", function GenerateFormsLibraryComponent_div_15_Template_lib_override_radio_button_library_generateUpload_8_listener($event) { i0.ɵɵrestoreView(_r77); const ctx_r76 = i0.ɵɵnextContext(); return ctx_r76.getInfoBack($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelement(9, "div", 13);
    i0.ɵɵtemplate(10, GenerateFormsLibraryComponent_div_15_div_10_Template, 5, 3, "div", 30);
    i0.ɵɵelementStart(11, "div", 10);
    i0.ɵɵelementStart(12, "lib-overide-upload-forms-library", 15);
    i0.ɵɵlistener("uploadData", function GenerateFormsLibraryComponent_div_15_Template_lib_overide_upload_forms_library_uploadData_12_listener($event) { i0.ɵɵrestoreView(_r77); const ctx_r78 = i0.ɵɵnextContext(); return ctx_r78.getUploadedData($event); })("deleteData", function GenerateFormsLibraryComponent_div_15_Template_lib_overide_upload_forms_library_deleteData_12_listener($event) { i0.ɵɵrestoreView(_r77); const ctx_r79 = i0.ɵɵnextContext(); return ctx_r79.getDeletedData($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext();
    i0.ɵɵadvance(8);
    i0.ɵɵproperty("primaryData", ctx_r8.primaryData)("fileName", "I130PREP")("isGenerated", ctx_r8.generateFormI130Prep);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r8.generateFormI130Prep);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("uploadedFileName", ctx_r8.uploadedFileNameI130PREP)("documentID", ctx_r8.documentId130PREP)("fileSrc", ctx_r8.i130PrepSrc)("UploadingTime", ctx_r8.i130PREPlastDocDate)("isUploaded", ctx_r8.uploadedFormI130PREP)("isGenerated", ctx_r8.generateFormI130Prep)("primaryData", ctx_r8.inputData)("formName", "I130PREP");
} }
function GenerateFormsLibraryComponent_div_16_div_10_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r84 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 21);
    i0.ɵɵelementStart(1, "button", 22);
    i0.ɵɵlistener("click", function GenerateFormsLibraryComponent_div_16_div_10_div_3_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r84); const ctx_r83 = i0.ɵɵnextContext(3); return ctx_r83.viewGenerateDoc(ctx_r83.i130IntptrSrc); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function GenerateFormsLibraryComponent_div_16_div_10_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 23);
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r82 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r82.i130INTPTRlastDocDate ? "Generated On " + ctx_r82.i130INTPTRlastDocDate : "", " ");
} }
function GenerateFormsLibraryComponent_div_16_div_10_Template(rf, ctx) { if (rf & 1) {
    const _r86 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵelementStart(1, "div", 17);
    i0.ɵɵelementStart(2, "button", 18);
    i0.ɵɵlistener("click", function GenerateFormsLibraryComponent_div_16_div_10_Template_button_click_2_listener() { i0.ɵɵrestoreView(_r86); const ctx_r85 = i0.ɵɵnextContext(2); return ctx_r85.postGenerateDoc("I130INTPTR"); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, GenerateFormsLibraryComponent_div_16_div_10_div_3_Template, 2, 0, "div", 19);
    i0.ɵɵtemplate(4, GenerateFormsLibraryComponent_div_16_div_10_div_4_Template, 3, 1, "div", 20);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r80 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", ctx_r80.disabledControls);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r80.generateFormI130INTPTR && ctx_r80.generateActiveI130INTPTR);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r80.generateFormI130INTPTR && ctx_r80.generateActiveI130INTPTR);
} }
function GenerateFormsLibraryComponent_div_16_Template(rf, ctx) { if (rf & 1) {
    const _r88 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 29);
    i0.ɵɵelementStart(2, "div", 10);
    i0.ɵɵelementStart(3, "label");
    i0.ɵɵelementStart(4, "b");
    i0.ɵɵtext(5, "Form I-130 Interpreter");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "p", 11);
    i0.ɵɵtext(7, "Would you like to use system generated form or upload your own form?");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "lib-override-radio-button-library", 12);
    i0.ɵɵlistener("generateUpload", function GenerateFormsLibraryComponent_div_16_Template_lib_override_radio_button_library_generateUpload_8_listener($event) { i0.ɵɵrestoreView(_r88); const ctx_r87 = i0.ɵɵnextContext(); return ctx_r87.getInfoBack($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelement(9, "div", 13);
    i0.ɵɵtemplate(10, GenerateFormsLibraryComponent_div_16_div_10_Template, 5, 3, "div", 14);
    i0.ɵɵelementStart(11, "div", 10);
    i0.ɵɵelementStart(12, "lib-overide-upload-forms-library", 15);
    i0.ɵɵlistener("uploadData", function GenerateFormsLibraryComponent_div_16_Template_lib_overide_upload_forms_library_uploadData_12_listener($event) { i0.ɵɵrestoreView(_r88); const ctx_r89 = i0.ɵɵnextContext(); return ctx_r89.getUploadedData($event); })("deleteData", function GenerateFormsLibraryComponent_div_16_Template_lib_overide_upload_forms_library_deleteData_12_listener($event) { i0.ɵɵrestoreView(_r88); const ctx_r90 = i0.ɵɵnextContext(); return ctx_r90.getDeletedData($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext();
    i0.ɵɵadvance(8);
    i0.ɵɵproperty("primaryData", ctx_r9.primaryData)("fileName", "I130INTPTR")("isGenerated", ctx_r9.generateFormI130INTPTR);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r9.generateFormI130INTPTR);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("uploadedFileName", ctx_r9.uploadedFileName130INTPTR)("documentID", ctx_r9.documentId130INTPTR)("fileSrc", ctx_r9.i130IntptrSrc)("UploadingTime", ctx_r9.i130INTPTRlastDocDate)("isUploaded", ctx_r9.uploadedFormI130INTPTR)("isGenerated", ctx_r9.generateFormI130INTPTR)("primaryData", ctx_r9.inputData)("formName", "I130INTPTR");
} }
function GenerateFormsLibraryComponent_div_17_div_14_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r95 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 21);
    i0.ɵɵelementStart(1, "button", 22);
    i0.ɵɵlistener("click", function GenerateFormsLibraryComponent_div_17_div_14_div_3_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r95); const ctx_r94 = i0.ɵɵnextContext(3); return ctx_r94.viewGenerateDoc(ctx_r94.i130ASrc); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function GenerateFormsLibraryComponent_div_17_div_14_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 23);
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r93 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r93.i130AlastDocDate ? "Generated On " + ctx_r93.i130AlastDocDate : "", " ");
} }
function GenerateFormsLibraryComponent_div_17_div_14_Template(rf, ctx) { if (rf & 1) {
    const _r97 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵelementStart(1, "div", 17);
    i0.ɵɵelementStart(2, "button", 18);
    i0.ɵɵlistener("click", function GenerateFormsLibraryComponent_div_17_div_14_Template_button_click_2_listener() { i0.ɵɵrestoreView(_r97); const ctx_r96 = i0.ɵɵnextContext(2); return ctx_r96.postGenerateDoc("I130A"); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, GenerateFormsLibraryComponent_div_17_div_14_div_3_Template, 2, 0, "div", 19);
    i0.ɵɵtemplate(4, GenerateFormsLibraryComponent_div_17_div_14_div_4_Template, 3, 1, "div", 20);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r91 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", ctx_r91.disabledControls);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r91.generateFormI130A && ctx_r91.generateActive130A);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r91.generateFormI130A && ctx_r91.generateActive130A);
} }
function GenerateFormsLibraryComponent_div_17_Template(rf, ctx) { if (rf & 1) {
    const _r99 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 24);
    i0.ɵɵelementStart(2, "h6");
    i0.ɵɵelementStart(3, "b");
    i0.ɵɵtext(4, "Petition for Alien Relative(Spouse)");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 25);
    i0.ɵɵelementStart(6, "div", 10);
    i0.ɵɵelementStart(7, "label");
    i0.ɵɵelementStart(8, "b");
    i0.ɵɵtext(9, "Form I-130A");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "p", 11);
    i0.ɵɵtext(11, "Would you like to use system generated form or upload your own form?");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "lib-override-radio-button-library", 12);
    i0.ɵɵlistener("generateUpload", function GenerateFormsLibraryComponent_div_17_Template_lib_override_radio_button_library_generateUpload_12_listener($event) { i0.ɵɵrestoreView(_r99); const ctx_r98 = i0.ɵɵnextContext(); return ctx_r98.getInfoBack($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelement(13, "div", 13);
    i0.ɵɵtemplate(14, GenerateFormsLibraryComponent_div_17_div_14_Template, 5, 3, "div", 14);
    i0.ɵɵelementStart(15, "div", 10);
    i0.ɵɵelementStart(16, "lib-overide-upload-forms-library", 15);
    i0.ɵɵlistener("uploadData", function GenerateFormsLibraryComponent_div_17_Template_lib_overide_upload_forms_library_uploadData_16_listener($event) { i0.ɵɵrestoreView(_r99); const ctx_r100 = i0.ɵɵnextContext(); return ctx_r100.getUploadedData($event); })("deleteData", function GenerateFormsLibraryComponent_div_17_Template_lib_overide_upload_forms_library_deleteData_16_listener($event) { i0.ɵɵrestoreView(_r99); const ctx_r101 = i0.ɵɵnextContext(); return ctx_r101.getDeletedData($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext();
    i0.ɵɵadvance(12);
    i0.ɵɵproperty("primaryData", ctx_r10.primaryData)("fileName", "I130A")("isGenerated", ctx_r10.generateFormI130A);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r10.generateFormI130A);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("uploadedFileName", ctx_r10.uploadedFileName130A)("documentID", ctx_r10.documentId130A)("fileSrc", ctx_r10.i130ASrc)("UploadingTime", ctx_r10.i130AlastDocDate)("isUploaded", ctx_r10.uploadedFormI130A)("isGenerated", ctx_r10.generateFormI130A)("primaryData", ctx_r10.inputData)("formName", "I130A");
} }
function GenerateFormsLibraryComponent_div_18_div_1_div_1_div_13_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r113 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 21);
    i0.ɵɵelementStart(1, "button", 22);
    i0.ɵɵlistener("click", function GenerateFormsLibraryComponent_div_18_div_1_div_1_div_13_div_3_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r113); const comItem_r106 = i0.ɵɵnextContext(2).$implicit; const ctx_r111 = i0.ɵɵnextContext(3); return ctx_r111.viewGenerateDoc(comItem_r106 == null ? null : comItem_r106.fileSrc); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function GenerateFormsLibraryComponent_div_18_div_1_div_1_div_13_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 23);
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const comItem_r106 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", comItem_r106.lastDocDate ? "Generated On " + comItem_r106.lastDocDate : "", " ");
} }
function GenerateFormsLibraryComponent_div_18_div_1_div_1_div_13_Template(rf, ctx) { if (rf & 1) {
    const _r117 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵelementStart(1, "div", 17);
    i0.ɵɵelementStart(2, "button", 18);
    i0.ɵɵlistener("click", function GenerateFormsLibraryComponent_div_18_div_1_div_1_div_13_Template_button_click_2_listener() { i0.ɵɵrestoreView(_r117); const comItem_r106 = i0.ɵɵnextContext().$implicit; const ctx_r115 = i0.ɵɵnextContext(3); return ctx_r115.postDependentGenerateDoc(comItem_r106 == null ? null : comItem_r106.code, comItem_r106 == null ? null : comItem_r106.applicantId, "false", comItem_r106 == null ? null : comItem_r106.relationshipCode); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, GenerateFormsLibraryComponent_div_18_div_1_div_1_div_13_div_3_Template, 2, 0, "div", 19);
    i0.ɵɵtemplate(4, GenerateFormsLibraryComponent_div_18_div_1_div_1_div_13_div_4_Template, 3, 1, "div", 20);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const comItem_r106 = i0.ɵɵnextContext().$implicit;
    const ctx_r108 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", ctx_r108.disabledControls);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (comItem_r106 == null ? null : comItem_r106.isGenerated) && (comItem_r106 == null ? null : comItem_r106.isActive));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (comItem_r106 == null ? null : comItem_r106.isGenerated) && (comItem_r106 == null ? null : comItem_r106.isActive));
} }
function GenerateFormsLibraryComponent_div_18_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r120 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 34);
    i0.ɵɵelementStart(1, "div", 25);
    i0.ɵɵelementStart(2, "div", 10);
    i0.ɵɵelementStart(3, "label");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 10);
    i0.ɵɵelementStart(6, "label");
    i0.ɵɵelementStart(7, "b");
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "p", 11);
    i0.ɵɵtext(10, "Would you like to use system generated form or upload your own form?");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "lib-override-radio-button-library", 35);
    i0.ɵɵlistener("generateUpload", function GenerateFormsLibraryComponent_div_18_div_1_div_1_Template_lib_override_radio_button_library_generateUpload_11_listener($event) { i0.ɵɵrestoreView(_r120); const ctx_r119 = i0.ɵɵnextContext(3); return ctx_r119.getInfoBack($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelement(12, "div", 13);
    i0.ɵɵtemplate(13, GenerateFormsLibraryComponent_div_18_div_1_div_1_div_13_Template, 5, 3, "div", 14);
    i0.ɵɵelementStart(14, "div", 10);
    i0.ɵɵelementStart(15, "lib-overide-upload-forms-library", 36);
    i0.ɵɵlistener("uploadData", function GenerateFormsLibraryComponent_div_18_div_1_div_1_Template_lib_overide_upload_forms_library_uploadData_15_listener($event) { i0.ɵɵrestoreView(_r120); const ctx_r121 = i0.ɵɵnextContext(3); return ctx_r121.getUploadedData($event); })("deleteData", function GenerateFormsLibraryComponent_div_18_div_1_div_1_Template_lib_overide_upload_forms_library_deleteData_15_listener($event) { i0.ɵɵrestoreView(_r120); const ctx_r122 = i0.ɵɵnextContext(3); return ctx_r122.getDeletedData($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const comItem_r106 = ctx.$implicit;
    const i_r107 = ctx.index;
    const ctx_r105 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate((ctx_r105.primaryData == null ? null : ctx_r105.primaryData.visatype) === "ASYLUM" || !(comItem_r106 == null ? null : comItem_r106.applicantName) ? comItem_r106 == null ? null : comItem_r106.name : comItem_r106 == null ? null : comItem_r106.applicantName);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1("Form ", comItem_r106 == null ? null : comItem_r106.name, "");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("primaryData", ctx_r105.primaryData)("formType", "common")("currentIndex", i_r107)("fileName", comItem_r106 == null ? null : comItem_r106.code)("isGenerated", comItem_r106 == null ? null : comItem_r106.isGenerated);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", comItem_r106 == null ? null : comItem_r106.isGenerated);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("uploadedFileName", comItem_r106 == null ? null : comItem_r106.uploadedFileName)("familyId", comItem_r106 == null ? null : comItem_r106.applicantId)("documentID", comItem_r106 == null ? null : comItem_r106.documentId)("formType", "common")("currentIndex", i_r107)("fileSrc", comItem_r106 == null ? null : comItem_r106.fileSrc)("UploadingTime", comItem_r106 == null ? null : comItem_r106.lastDocDate)("isUploaded", comItem_r106 == null ? null : comItem_r106.isUploaded)("isGenerated", comItem_r106 == null ? null : comItem_r106.isGenerated)("primaryData", ctx_r105.inputData)("formName", comItem_r106 == null ? null : comItem_r106.code);
} }
function GenerateFormsLibraryComponent_div_18_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, GenerateFormsLibraryComponent_div_18_div_1_div_1_Template, 16, 19, "div", 33);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r102 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r102.formDataArray.common);
} }
function GenerateFormsLibraryComponent_div_18_div_2_div_1_div_13_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r131 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 21);
    i0.ɵɵelementStart(1, "button", 22);
    i0.ɵɵlistener("click", function GenerateFormsLibraryComponent_div_18_div_2_div_1_div_13_div_3_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r131); const item_r124 = i0.ɵɵnextContext(2).$implicit; const ctx_r129 = i0.ɵɵnextContext(3); return ctx_r129.viewGenerateDoc(item_r124 == null ? null : item_r124.fileSrc); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function GenerateFormsLibraryComponent_div_18_div_2_div_1_div_13_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 23);
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r124 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", item_r124.lastDocDate ? "Generated On " + item_r124.lastDocDate : "", " ");
} }
function GenerateFormsLibraryComponent_div_18_div_2_div_1_div_13_Template(rf, ctx) { if (rf & 1) {
    const _r135 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵelementStart(1, "div", 17);
    i0.ɵɵelementStart(2, "button", 18);
    i0.ɵɵlistener("click", function GenerateFormsLibraryComponent_div_18_div_2_div_1_div_13_Template_button_click_2_listener() { i0.ɵɵrestoreView(_r135); const item_r124 = i0.ɵɵnextContext().$implicit; const ctx_r133 = i0.ɵɵnextContext(3); return ctx_r133.postDependentGenerateDoc(item_r124 == null ? null : item_r124.code, item_r124 == null ? null : item_r124.applicantId, "false", item_r124 == null ? null : item_r124.relationshipCode); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, GenerateFormsLibraryComponent_div_18_div_2_div_1_div_13_div_3_Template, 2, 0, "div", 19);
    i0.ɵɵtemplate(4, GenerateFormsLibraryComponent_div_18_div_2_div_1_div_13_div_4_Template, 3, 1, "div", 20);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r124 = i0.ɵɵnextContext().$implicit;
    const ctx_r126 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", ctx_r126.disabledControls);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (item_r124 == null ? null : item_r124.isGenerated) && (item_r124 == null ? null : item_r124.isActive));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (item_r124 == null ? null : item_r124.isGenerated) && (item_r124 == null ? null : item_r124.isActive));
} }
function GenerateFormsLibraryComponent_div_18_div_2_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r138 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 34);
    i0.ɵɵelementStart(1, "div", 25);
    i0.ɵɵelementStart(2, "div", 10);
    i0.ɵɵelementStart(3, "label");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 10);
    i0.ɵɵelementStart(6, "label");
    i0.ɵɵelementStart(7, "b");
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "p", 11);
    i0.ɵɵtext(10, "Would you like to use system generated form or upload your own form?");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "lib-override-radio-button-library", 35);
    i0.ɵɵlistener("generateUpload", function GenerateFormsLibraryComponent_div_18_div_2_div_1_Template_lib_override_radio_button_library_generateUpload_11_listener($event) { i0.ɵɵrestoreView(_r138); const ctx_r137 = i0.ɵɵnextContext(3); return ctx_r137.getInfoBack($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelement(12, "div", 13);
    i0.ɵɵtemplate(13, GenerateFormsLibraryComponent_div_18_div_2_div_1_div_13_Template, 5, 3, "div", 14);
    i0.ɵɵelementStart(14, "div", 10);
    i0.ɵɵelementStart(15, "lib-overide-upload-forms-library", 36);
    i0.ɵɵlistener("uploadData", function GenerateFormsLibraryComponent_div_18_div_2_div_1_Template_lib_overide_upload_forms_library_uploadData_15_listener($event) { i0.ɵɵrestoreView(_r138); const ctx_r139 = i0.ɵɵnextContext(3); return ctx_r139.getUploadedData($event); })("deleteData", function GenerateFormsLibraryComponent_div_18_div_2_div_1_Template_lib_overide_upload_forms_library_deleteData_15_listener($event) { i0.ɵɵrestoreView(_r138); const ctx_r140 = i0.ɵɵnextContext(3); return ctx_r140.getDeletedData($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r124 = ctx.$implicit;
    const i_r125 = ctx.index;
    const ctx_r123 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate((ctx_r123.primaryData == null ? null : ctx_r123.primaryData.visatype) === "ASYLUM" || !(item_r124 == null ? null : item_r124.applicantName) ? item_r124 == null ? null : item_r124.name : item_r124 == null ? null : item_r124.applicantName);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1("Form ", item_r124 == null ? null : item_r124.name, "");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("primaryData", ctx_r123.primaryData)("formType", "primary")("currentIndex", i_r125)("fileName", item_r124 == null ? null : item_r124.code)("isGenerated", item_r124 == null ? null : item_r124.isGenerated);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", item_r124 == null ? null : item_r124.isGenerated);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("uploadedFileName", item_r124 == null ? null : item_r124.uploadedFileName)("familyId", item_r124 == null ? null : item_r124.applicantId)("documentID", item_r124 == null ? null : item_r124.documentId)("formType", "primary")("currentIndex", i_r125)("fileSrc", item_r124 == null ? null : item_r124.fileSrc)("UploadingTime", item_r124 == null ? null : item_r124.lastDocDate)("isUploaded", item_r124 == null ? null : item_r124.isUploaded)("isGenerated", item_r124 == null ? null : item_r124.isGenerated)("primaryData", ctx_r123.inputData)("formName", item_r124 == null ? null : item_r124.code);
} }
function GenerateFormsLibraryComponent_div_18_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, GenerateFormsLibraryComponent_div_18_div_2_div_1_Template, 16, 19, "div", 33);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r103 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r103.formDataArray.primary);
} }
function GenerateFormsLibraryComponent_div_18_div_3_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r147 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 41);
    i0.ɵɵelementStart(1, "button", 42);
    i0.ɵɵlistener("click", function GenerateFormsLibraryComponent_div_18_div_3_div_1_div_1_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r147); const item1_r142 = i0.ɵɵnextContext().$implicit; const ctx_r145 = i0.ɵɵnextContext(3); return ctx_r145.postDependentGenerateDoc(item1_r142.code, 0, "true", item1_r142.relationshipCode); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r143 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", ctx_r143.disabledControls);
} }
function GenerateFormsLibraryComponent_div_18_div_3_div_1_div_5_div_10_Template(rf, ctx) { if (rf & 1) {
    const _r155 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵelementStart(1, "button", 18);
    i0.ɵɵlistener("click", function GenerateFormsLibraryComponent_div_18_div_3_div_1_div_5_div_10_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r155); const secApplicant_r148 = i0.ɵɵnextContext().$implicit; const item1_r142 = i0.ɵɵnextContext().$implicit; const ctx_r153 = i0.ɵɵnextContext(3); return ctx_r153.postDependentGenerateDoc(item1_r142.code, secApplicant_r148.applicantId, "false", secApplicant_r148 == null ? null : secApplicant_r148.relationshipCode); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r150 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", ctx_r150.disabledControls);
} }
function GenerateFormsLibraryComponent_div_18_div_3_div_1_div_5_div_11_Template(rf, ctx) { if (rf & 1) {
    const _r159 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 21);
    i0.ɵɵelementStart(1, "button", 22);
    i0.ɵɵlistener("click", function GenerateFormsLibraryComponent_div_18_div_3_div_1_div_5_div_11_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r159); const secApplicant_r148 = i0.ɵɵnextContext().$implicit; const ctx_r157 = i0.ɵɵnextContext(4); return ctx_r157.viewGenerateDoc(secApplicant_r148.fileSrc); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function GenerateFormsLibraryComponent_div_18_div_3_div_1_div_5_div_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 23);
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const secApplicant_r148 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", secApplicant_r148.lastDocDate ? "Generated On " + secApplicant_r148.lastDocDate : "", " ");
} }
function GenerateFormsLibraryComponent_div_18_div_3_div_1_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r162 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 25);
    i0.ɵɵelementStart(1, "div", 10);
    i0.ɵɵelementStart(2, "label");
    i0.ɵɵelementStart(3, "b");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "p", 11);
    i0.ɵɵtext(6, "Would you like to use system generated form or upload your own form?");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "lib-override-radio-button-library", 35);
    i0.ɵɵlistener("generateUpload", function GenerateFormsLibraryComponent_div_18_div_3_div_1_div_5_Template_lib_override_radio_button_library_generateUpload_7_listener($event) { i0.ɵɵrestoreView(_r162); const ctx_r161 = i0.ɵɵnextContext(4); return ctx_r161.getInfoBack($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelement(8, "div", 13);
    i0.ɵɵelementStart(9, "div", 16);
    i0.ɵɵtemplate(10, GenerateFormsLibraryComponent_div_18_div_3_div_1_div_5_div_10_Template, 2, 1, "div", 43);
    i0.ɵɵtemplate(11, GenerateFormsLibraryComponent_div_18_div_3_div_1_div_5_div_11_Template, 2, 0, "div", 19);
    i0.ɵɵtemplate(12, GenerateFormsLibraryComponent_div_18_div_3_div_1_div_5_div_12_Template, 3, 1, "div", 20);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "div", 10);
    i0.ɵɵelementStart(14, "lib-overide-upload-forms-library", 36);
    i0.ɵɵlistener("uploadData", function GenerateFormsLibraryComponent_div_18_div_3_div_1_div_5_Template_lib_overide_upload_forms_library_uploadData_14_listener($event) { i0.ɵɵrestoreView(_r162); const ctx_r163 = i0.ɵɵnextContext(4); return ctx_r163.getUploadedData($event); })("deleteData", function GenerateFormsLibraryComponent_div_18_div_3_div_1_div_5_Template_lib_overide_upload_forms_library_deleteData_14_listener($event) { i0.ɵɵrestoreView(_r162); const ctx_r164 = i0.ɵɵnextContext(4); return ctx_r164.getDeletedData($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const secApplicant_r148 = ctx.$implicit;
    const i_r149 = ctx.index;
    const item1_r142 = i0.ɵɵnextContext().$implicit;
    const ctx_r144 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate((secApplicant_r148 == null ? null : secApplicant_r148.applicantName) ? secApplicant_r148 == null ? null : secApplicant_r148.applicantName : item1_r142 == null ? null : item1_r142.name);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("primaryData", ctx_r144.primaryData)("formType", "secondary")("currentIndex", i_r149)("fileName", item1_r142 == null ? null : item1_r142.code)("isGenerated", secApplicant_r148 == null ? null : secApplicant_r148.isGenerated);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", secApplicant_r148 == null ? null : secApplicant_r148.isGenerated);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (secApplicant_r148 == null ? null : secApplicant_r148.isGenerated) && (secApplicant_r148 == null ? null : secApplicant_r148.isActive));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (secApplicant_r148 == null ? null : secApplicant_r148.isGenerated) && (secApplicant_r148 == null ? null : secApplicant_r148.isActive));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("uploadedFileName", secApplicant_r148 == null ? null : secApplicant_r148.uploadedFileName)("familyId", secApplicant_r148 == null ? null : secApplicant_r148.applicantId)("documentID", secApplicant_r148 == null ? null : secApplicant_r148.documentId)("formType", "secondary")("currentIndex", i_r149)("fileSrc", secApplicant_r148.fileSrc)("UploadingTime", secApplicant_r148.lastDocDate)("isUploaded", secApplicant_r148 == null ? null : secApplicant_r148.isUploaded)("isGenerated", secApplicant_r148 == null ? null : secApplicant_r148.isGenerated)("primaryData", ctx_r144.inputData)("formName", item1_r142 == null ? null : item1_r142.code);
} }
function GenerateFormsLibraryComponent_div_18_div_3_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 34);
    i0.ɵɵtemplate(1, GenerateFormsLibraryComponent_div_18_div_3_div_1_div_1_Template, 2, 1, "div", 37);
    i0.ɵɵelementStart(2, "div", 38);
    i0.ɵɵelementStart(3, "span", 39);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, GenerateFormsLibraryComponent_div_18_div_3_div_1_div_5_Template, 15, 20, "div", 40);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item1_r142 = ctx.$implicit;
    const ctx_r141 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r141.formDataArray == null ? null : ctx_r141.formDataArray.secondary[0] == null ? null : ctx_r141.formDataArray.secondary[0].secondaryApplicantNameList == null ? null : ctx_r141.formDataArray.secondary[0].secondaryApplicantNameList.length) > 1);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("Form ", item1_r142 == null ? null : item1_r142.name, "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", item1_r142.secondaryApplicantNameList);
} }
function GenerateFormsLibraryComponent_div_18_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, GenerateFormsLibraryComponent_div_18_div_3_div_1_Template, 6, 3, "div", 33);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r104 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r104.formDataArray.secondary);
} }
function GenerateFormsLibraryComponent_div_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 32);
    i0.ɵɵtemplate(1, GenerateFormsLibraryComponent_div_18_div_1_Template, 2, 1, "div", 6);
    i0.ɵɵtemplate(2, GenerateFormsLibraryComponent_div_18_div_2_Template, 2, 1, "div", 6);
    i0.ɵɵtemplate(3, GenerateFormsLibraryComponent_div_18_div_3_Template, 2, 1, "div", 6);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r11.dependentFormInfo == null ? null : ctx_r11.dependentFormInfo.formDetail) && (ctx_r11.dependentFormInfo == null ? null : ctx_r11.dependentFormInfo.formDetail == null ? null : ctx_r11.dependentFormInfo.formDetail.govtAgencyCode) != "USCIS" && ctx_r11.formDataArray.common.length > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r11.formDataArray.primary.length > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r11.formDataArray.secondary.length > 0);
} }
function GenerateFormsLibraryComponent_div_19_div_1_div_1_div_4_div_11_Template(rf, ctx) { if (rf & 1) {
    const _r178 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵelementStart(1, "button", 18);
    i0.ɵɵlistener("click", function GenerateFormsLibraryComponent_div_19_div_1_div_1_div_4_div_11_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r178); const item_r171 = i0.ɵɵnextContext().$implicit; const item1_r167 = i0.ɵɵnextContext(2).$implicit; const ctx_r176 = i0.ɵɵnextContext(2); return ctx_r176.postDependentGenerateDoc(item1_r167 == null ? null : item1_r167.formType == null ? null : item1_r167.formType.code, item_r171 == null ? null : item_r171.id, item_r171 == null ? null : item_r171.primaryApplicant, item_r171 == null ? null : item_r171.relationshipCode); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r173 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", ctx_r173.disabledControls);
} }
function GenerateFormsLibraryComponent_div_19_div_1_div_1_div_4_div_12_Template(rf, ctx) { if (rf & 1) {
    const _r182 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 21);
    i0.ɵɵelementStart(1, "button", 22);
    i0.ɵɵlistener("click", function GenerateFormsLibraryComponent_div_19_div_1_div_1_div_4_div_12_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r182); const item_r171 = i0.ɵɵnextContext().$implicit; const ctx_r180 = i0.ɵɵnextContext(4); return ctx_r180.viewGenerateDoc(item_r171 == null ? null : item_r171.fileSrc); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function GenerateFormsLibraryComponent_div_19_div_1_div_1_div_4_div_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 23);
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r171 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", (item_r171 == null ? null : item_r171.lastDocDate) ? "Generated On " + (item_r171 == null ? null : item_r171.lastDocDate) : "", " ");
} }
function GenerateFormsLibraryComponent_div_19_div_1_div_1_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r185 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 46);
    i0.ɵɵelementStart(1, "div", 25);
    i0.ɵɵelementStart(2, "div", 10);
    i0.ɵɵelementStart(3, "label");
    i0.ɵɵelementStart(4, "b");
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "p", 11);
    i0.ɵɵtext(7, "Would you like to use system generated form or upload your own form?");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "lib-override-radio-button-library", 47);
    i0.ɵɵlistener("generateUpload", function GenerateFormsLibraryComponent_div_19_div_1_div_1_div_4_Template_lib_override_radio_button_library_generateUpload_8_listener($event) { i0.ɵɵrestoreView(_r185); const ctx_r184 = i0.ɵɵnextContext(4); return ctx_r184.getInfoBack($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelement(9, "div", 13);
    i0.ɵɵelementStart(10, "div", 16);
    i0.ɵɵtemplate(11, GenerateFormsLibraryComponent_div_19_div_1_div_1_div_4_div_11_Template, 2, 1, "div", 43);
    i0.ɵɵtemplate(12, GenerateFormsLibraryComponent_div_19_div_1_div_1_div_4_div_12_Template, 2, 0, "div", 19);
    i0.ɵɵtemplate(13, GenerateFormsLibraryComponent_div_19_div_1_div_1_div_4_div_13_Template, 3, 1, "div", 20);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "div", 10);
    i0.ɵɵelementStart(15, "lib-overide-upload-forms-library", 48);
    i0.ɵɵlistener("uploadData", function GenerateFormsLibraryComponent_div_19_div_1_div_1_div_4_Template_lib_overide_upload_forms_library_uploadData_15_listener($event) { i0.ɵɵrestoreView(_r185); const ctx_r186 = i0.ɵɵnextContext(4); return ctx_r186.getUploadedData($event); })("deleteData", function GenerateFormsLibraryComponent_div_19_div_1_div_1_div_4_Template_lib_overide_upload_forms_library_deleteData_15_listener($event) { i0.ɵɵrestoreView(_r185); const ctx_r187 = i0.ɵɵnextContext(4); return ctx_r187.getDeletedData($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r171 = ctx.$implicit;
    const i_r172 = ctx.index;
    const ctx_r188 = i0.ɵɵnextContext(2);
    const index_r168 = ctx_r188.index;
    const item1_r167 = ctx_r188.$implicit;
    const ctx_r170 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate((ctx_r170.primaryData == null ? null : ctx_r170.primaryData.visatype) === "ASYLUM" && (item_r171 == null ? null : item_r171.name) ? item_r171 == null ? null : item_r171.name : (item_r171 == null ? null : item_r171.firstName) + " " + (item_r171 == null ? null : item_r171.lastName));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("primaryData", ctx_r170.primaryData)("formType", "dependentForm")("currentIndex", index_r168)("subIndex", i_r172)("fileName", item1_r167 == null ? null : item1_r167.formType.code)("isGenerated", item_r171 == null ? null : item_r171.isGenerated);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", item_r171 == null ? null : item_r171.isGenerated);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (item_r171 == null ? null : item_r171.isGenerated) && (item_r171 == null ? null : item_r171.isActive));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (item_r171 == null ? null : item_r171.isGenerated) && (item_r171 == null ? null : item_r171.isActive));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("familyId", item_r171 == null ? null : item_r171.familyId)("uploadedFileName", item_r171 == null ? null : item_r171.uploadedFileName)("currentIndex", index_r168)("subIndex", i_r172)("documentID", item_r171 == null ? null : item_r171.documentId)("formType", "dependentForm")("fileSrc", item_r171 == null ? null : item_r171.fileSrc)("UploadingTime", item_r171 == null ? null : item_r171.lastDocDate)("isUploaded", item_r171 == null ? null : item_r171.isUploaded)("isGenerated", item_r171 == null ? null : item_r171.isGenerated)("primaryData", ctx_r170.inputData)("formName", item1_r167 == null ? null : item1_r167.formType.code);
} }
function GenerateFormsLibraryComponent_div_19_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 38);
    i0.ɵɵelementStart(2, "span", 39);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, GenerateFormsLibraryComponent_div_19_div_1_div_1_div_4_Template, 16, 22, "div", 45);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item1_r167 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("Form ", item1_r167 == null ? null : item1_r167.formType == null ? null : item1_r167.formType.name, "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", item1_r167 == null ? null : item1_r167.applicantList);
} }
function GenerateFormsLibraryComponent_div_19_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, GenerateFormsLibraryComponent_div_19_div_1_div_1_Template, 5, 2, "div", 6);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item1_r167 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (item1_r167 == null ? null : item1_r167.applicantList == null ? null : item1_r167.applicantList.length) > 0);
} }
function GenerateFormsLibraryComponent_div_19_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 32);
    i0.ɵɵtemplate(1, GenerateFormsLibraryComponent_div_19_div_1_Template, 2, 1, "div", 44);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r12.dependentFormInfo == null ? null : ctx_r12.dependentFormInfo.generateFormFor);
} }
class GenerateFormsLibraryComponent extends BaseGenerateFormsLibraryService {
    // otherDocumentsFileUploadConfigurations: I140FileUploadConfiguration;
    constructor(store, toastr, apiService, stepStatusUpdatePayloadCostructionService, referenceLibraryService, cRef) {
        super(store, toastr, apiService, stepStatusUpdatePayloadCostructionService, referenceLibraryService);
        this.store = store;
        this.toastr = toastr;
        this.apiService = apiService;
        this.stepStatusUpdatePayloadCostructionService = stepStatusUpdatePayloadCostructionService;
        this.referenceLibraryService = referenceLibraryService;
        this.cRef = cRef;
        this.onDialogClose = new EventEmitter();
        this.isWizard = false;
    }
    ngOnInit() {
        localStorage.setItem("overrideRadioG28", null);
        localStorage.setItem("overrideRadioI129", null);
        localStorage.setItem("overrideRadioI907", null);
        localStorage.setItem("overrideRadioI130", null);
        localStorage.setItem("overrideRadioI130A", null);
        localStorage.setItem("overrideRadioI130PREP", null);
        localStorage.setItem("overrideRadioI130INTPTR", null);
        this.inputData = this.primaryData;
        super.loadInit();
    }
    ngOnChanges() {
    }
    handleClose() {
        this.onDialogClose.emit();
    }
    ngOnDestroy() {
        super.onDestroy();
    }
    getInfoBack(value) {
        if (value.key == 'I129') {
            this.generateFormI129 = value.isGenerate;
        }
        else if (value.key == 'I907') {
            this.generateFormI907 = value.isGenerate;
        }
        else if (value.key == 'G28') {
            this.generateFormG28 = value.isGenerate;
        }
        else if (value.key == 'I130') {
            this.generateFormI130 = value.isGenerate;
        }
        else if (value.key == 'I130A') {
            this.generateFormI130A = value.isGenerate;
        }
        else if (value.key == 'I130PREP') {
            this.generateFormI130Prep = value.isGenerate;
        }
        else if (value.key == 'I130INTPTR') {
            this.generateFormI130INTPTR = value.isGenerate;
        }
        else {
            if (value.formType == 'primary') {
                this.formDataArray.primary[value.currentIndex].isGenerated = value.isGenerate;
            }
            else if (value.formType == 'common') {
                this.formDataArray.common[value.currentIndex].isGenerated = value.isGenerate;
            }
            else if (value.formType == 'secondary') {
                this.formDataArray.secondary[value.currentIndex].secondaryApplicantNameList[0].isGenerated = value.isGenerate;
            }
            else if (value.formType == 'dependentForm') {
                this.dependentFormInfo.generateFormFor[value.currentIndex].applicantList[value.subIndex].isGenerated = value.isGenerate;
            }
        }
    }
    getUploadedData(_data) {
        this.assignLatestValues(_data);
    }
    getDeletedData(_data) {
        this.assignLatestValues(_data);
    }
    assignLatestValues(_data) {
        if (_data.fileName == 'I129') {
            this.generateFormI129 = _data.isGenerated;
            this.uploadedFormI129 = _data.isUploaded;
            this.i129LastDocDate = _data.generatedOn;
            this.documentId129 = _data.documentID;
            this.i129Src = _data.getUrl;
            this.uploadedFileName129 = _data.uploadedFileName;
            this.generateActive129 = _data.isActive;
        }
        else if (_data.fileName == 'I907') {
            this.generateFormI907 = _data.isGenerated;
            this.uploadedFormI907 = _data.isUploaded;
            this.i907lastDocDate = _data.generatedOn;
            this.documentId907 = _data.documentID;
            this.i907Src = _data.getUrl;
            this.uploadedFileName907 = _data.uploadedFileName;
            this.generateActive907 = _data.isActive;
        }
        else if (_data.fileName == 'G28') {
            this.generateFormG28 = _data.isGenerated;
            this.uploadedFormG28 = _data.isUploaded;
            this.g28lastDocDate = _data.generatedOn;
            this.documentIdG28 = _data.documentID;
            this.g28Src = _data.getUrl;
            this.uploadedFileNameG28 = _data.uploadedFileName;
            this.generateActiveG28 = _data.isActive;
        }
        else if (_data.fileName == 'I130') {
            this.generateFormI130 = _data.isGenerated;
            this.uploadedFormI130 = _data.isUploaded;
            this.i130lastDocDate = _data.generatedOn;
            this.documentId130 = _data.documentID;
            this.i130Src = _data.getUrl;
            this.uploadedFileName130 = _data.uploadedFileName;
            this.generateActive130 = _data.isActive;
        }
        else if (_data.fileName == 'I130A') {
            this.generateFormI130A = _data.generatedOn;
            this.uploadedFormI130A = _data.isUploaded;
            this.i130AlastDocDate = _data.generatedOn;
            this.documentId130A = _data.documentID;
            this.i130ASrc = _data.getUrl;
            this.uploadedFileName130A = _data.uploadedFileName;
            this.generateActive130A = _data.isActive;
        }
        else if (_data.fileName == 'I130PREP') {
            this.generateFormI130Prep = _data.generatedOn;
            this.uploadedFormI130PREP = _data.isUploaded;
            this.i130PREPlastDocDate = _data.generatedOn;
            this.documentId130PREP = _data.documentID;
            this.i130PrepSrc = _data.getUrl;
            this.uploadedFileNameI130PREP = _data.uploadedFileName;
            this.generateActiveI130Prep = _data.isActive;
        }
        else if (_data.fileName == 'I130INTPTR') {
            this.generateFormI130INTPTR = _data.generatedOn;
            this.uploadedFormI130INTPTR = _data.isUploaded;
            this.i130INTPTRlastDocDate = _data.generatedOn;
            this.documentId130INTPTR = _data.documentID;
            this.i130IntptrSrc = _data.getUrl;
            this.uploadedFileName130INTPTR = _data.uploadedFileName;
            this.generateActiveI130INTPTR = _data.isActive;
        }
        else {
            if (_data.formType == 'primary') {
                this.formDataArray.primary[_data.currentIndex].isGenerated = _data.isGenerated;
                this.formDataArray.primary[_data.currentIndex].isUploaded = _data.isUploaded;
                this.formDataArray.primary[_data.currentIndex].documentId = _data.documentID;
                this.formDataArray.primary[_data.currentIndex].fileSrc = _data.getUrl;
                this.formDataArray.primary[_data.currentIndex].lastDocDate = _data.generatedOn;
                this.formDataArray.primary[_data.currentIndex].uploadedFileName = _data.uploadedFileName;
                this.formDataArray.primary[_data.currentIndex].isActive = _data.isActive;
            }
            else if (_data.formType == 'secondary') {
                this.formDataArray.secondary[0].secondaryApplicantNameList[_data.currentIndex].isGenerated = _data.isGenerated;
                this.formDataArray.secondary[0].secondaryApplicantNameList[_data.currentIndex].isUploaded = _data.isUploaded;
                this.formDataArray.secondary[0].secondaryApplicantNameList[_data.currentIndex].documentId = _data.documentID;
                this.formDataArray.secondary[0].secondaryApplicantNameList[_data.currentIndex].fileSrc = _data.getUrl;
                this.formDataArray.secondary[0].secondaryApplicantNameList[_data.currentIndex].lastDocDate = _data.generatedOn;
                this.formDataArray.secondary[0].secondaryApplicantNameList[_data.currentIndex].uploadedFileName = _data.uploadedFileName;
                this.formDataArray.secondary[0].secondaryApplicantNameList[_data.currentIndex].isActive = _data.isActive;
            }
            else if (_data.formType == 'dependentForm') {
                this.dependentFormInfo.generateFormFor[_data.currentIndex].applicantList[_data.subIndex].isGenerated = _data.isGenerated;
                this.dependentFormInfo.generateFormFor[_data.currentIndex].applicantList[_data.subIndex].isUploaded = _data.isUploaded;
                this.dependentFormInfo.generateFormFor[_data.currentIndex].applicantList[_data.subIndex].lastDocDate = _data.generatedOn;
                this.dependentFormInfo.generateFormFor[_data.currentIndex].applicantList[_data.subIndex].documentId = _data.documentID;
                this.dependentFormInfo.generateFormFor[_data.currentIndex].applicantList[_data.subIndex].fileSrc = _data.getUrl;
                this.dependentFormInfo.generateFormFor[_data.currentIndex].applicantList[_data.subIndex].uploadedFileName = _data.uploadedFileName;
                this.dependentFormInfo.generateFormFor[_data.currentIndex].applicantList[_data.subIndex].isActive = _data.isActive;
            }
            else if (_data.formType == 'common') {
                this.formDataArray.common[_data.currentIndex].isGenerated = _data.isGenerated;
                this.formDataArray.common[_data.currentIndex].isUploaded = _data.isUploaded;
                this.formDataArray.common[_data.currentIndex].documentId = _data.documentID;
                this.formDataArray.common[_data.currentIndex].fileSrc = _data.getUrl;
                this.formDataArray.common[_data.currentIndex].lastDocDate = _data.generatedOn;
                this.formDataArray.common[_data.currentIndex].uploadedFileName = _data.uploadedFileName;
                this.formDataArray.common[_data.currentIndex].isActive = _data.isActive;
            }
        }
    }
}
GenerateFormsLibraryComponent.ɵfac = function GenerateFormsLibraryComponent_Factory(t) { return new (t || GenerateFormsLibraryComponent)(i0.ɵɵdirectiveInject(i1.Store), i0.ɵɵdirectiveInject(i2.ToastrService), i0.ɵɵdirectiveInject(i3.APIGenerateForms), i0.ɵɵdirectiveInject(i4.StepStatusUpdatePayloadService), i0.ɵɵdirectiveInject(i5.ReferenceLibraryService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
GenerateFormsLibraryComponent.ɵcmp = i0.ɵɵdefineComponent({ type: GenerateFormsLibraryComponent, selectors: [["generate-forms-library"]], inputs: { primaryData: "primaryData", formDataArray: "formDataArray", formType: "formType", isWizard: "isWizard" }, outputs: { onDialogClose: "onDialogClose" }, features: [i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature], decls: 20, vars: 13, consts: [[1, "row", "col-md-12"], [1, "heading", "mb-0"], [2, "font-size", "12px"], ["class", "row col-md-12 pt-2", 4, "ngIf"], ["class", "row form-box d-flex align-items-center", 4, "ngIf"], ["class", "row col-md-12 pt-4", 4, "ngIf"], [4, "ngIf"], ["class", "mb-2", 4, "ngIf"], [1, "row", "col-md-12", "pt-2"], [1, "row", "form-box", "d-flex", "align-items-center"], [1, "col-12"], [2, "font-size", "14px"], [3, "primaryData", "fileName", "isGenerated", "generateUpload"], [1, "clearfix"], ["class", "generateBtnContainer row", 4, "ngIf"], [3, "uploadedFileName", "documentID", "fileSrc", "UploadingTime", "isUploaded", "isGenerated", "primaryData", "formName", "uploadData", "deleteData"], [1, "generateBtnContainer", "row"], [1, "col-2"], ["pButton", "", "label", "Generate", "title", "Generate", 1, "btn-success", "button-width-icon-left", "btn-small", "mr-1", "pl-3", "pr-3", "save-btn", 3, "disabled", "click"], ["class", "col-3", 4, "ngIf"], ["class", "col-5", 4, "ngIf"], [1, "col-3"], ["pButton", "", "type", "button", "label", "View PDF", "title", "View PDF", 1, "p-button-outlined", "btn-small", 3, "click"], [1, "col-5"], [1, "row", "col-md-12", "pt-4"], [1, "row", "form-box", "d-flex", "align-items-center", "pb-3"], ["pButton", "", "label", "Generate", "title", "Generate", 1, "btn-success", "button-width-icon-left", "mr-1", "pl-3", "pr-3", "save-btn", 3, "disabled", "click"], ["pButton", "", "type", "button", "label", "View PDF", "title", "View PDF", "class", "p-button-outlined", 3, "click", 4, "ngIf"], ["pButton", "", "type", "button", "label", "View PDF", "title", "View PDF", 1, "p-button-outlined", 3, "click"], [1, "row", "form-box", "d-flex", "align-items-center", "pb-3", "mt-4"], ["class", "generateBtnContainer row pt-4", 4, "ngIf"], [1, "generateBtnContainer", "row", "pt-4"], [1, "mb-2"], ["class", "mt-2", 4, "ngFor", "ngForOf"], [1, "mt-2"], [3, "primaryData", "formType", "currentIndex", "fileName", "isGenerated", "generateUpload"], [3, "uploadedFileName", "familyId", "documentID", "formType", "currentIndex", "fileSrc", "UploadingTime", "isUploaded", "isGenerated", "primaryData", "formName", "uploadData", "deleteData"], ["class", "d-flex justify-content-end", 4, "ngIf"], [1, "row", "pl-3", "pb-3"], [1, "form-type-title"], ["class", "row form-box d-flex align-items-center pb-3", 4, "ngFor", "ngForOf"], [1, "d-flex", "justify-content-end"], ["pButton", "", "label", "Generate All", "title", "Generate All", 1, "btn-primary", "button-width-icon-left", "mr-1", "pl-3", "pr-3", "btn-success_disabled", "save-btn", 3, "disabled", "click"], ["class", "col-2", 4, "ngIf"], [4, "ngFor", "ngForOf"], ["style", "margin-bottom: 10px;", 4, "ngFor", "ngForOf"], [2, "margin-bottom", "10px"], [3, "primaryData", "formType", "currentIndex", "subIndex", "fileName", "isGenerated", "generateUpload"], [3, "familyId", "uploadedFileName", "currentIndex", "subIndex", "documentID", "formType", "fileSrc", "UploadingTime", "isUploaded", "isGenerated", "primaryData", "formName", "uploadData", "deleteData"]], template: function GenerateFormsLibraryComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "h6", 1);
        i0.ɵɵtext(2, "Generate Forms");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "div", 0);
        i0.ɵɵelementStart(4, "p", 2);
        i0.ɵɵelementStart(5, "i");
        i0.ɵɵtext(6, "You will need all the following documents for filing");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(7, GenerateFormsLibraryComponent_div_7_Template, 4, 0, "div", 3);
        i0.ɵɵtemplate(8, GenerateFormsLibraryComponent_div_8_Template, 12, 12, "div", 4);
        i0.ɵɵtemplate(9, GenerateFormsLibraryComponent_div_9_Template, 4, 0, "div", 5);
        i0.ɵɵtemplate(10, GenerateFormsLibraryComponent_div_10_Template, 11, 12, "div", 4);
        i0.ɵɵtemplate(11, GenerateFormsLibraryComponent_div_11_Template, 16, 12, "div", 6);
        i0.ɵɵtemplate(12, GenerateFormsLibraryComponent_div_12_Template, 14, 3, "div", 6);
        i0.ɵɵtemplate(13, GenerateFormsLibraryComponent_div_13_Template, 14, 3, "div", 6);
        i0.ɵɵtemplate(14, GenerateFormsLibraryComponent_div_14_Template, 17, 12, "div", 6);
        i0.ɵɵtemplate(15, GenerateFormsLibraryComponent_div_15_Template, 13, 12, "div", 6);
        i0.ɵɵtemplate(16, GenerateFormsLibraryComponent_div_16_Template, 13, 12, "div", 6);
        i0.ɵɵtemplate(17, GenerateFormsLibraryComponent_div_17_Template, 17, 12, "div", 6);
        i0.ɵɵtemplate(18, GenerateFormsLibraryComponent_div_18_Template, 4, 3, "div", 7);
        i0.ɵɵtemplate(19, GenerateFormsLibraryComponent_div_19_Template, 2, 1, "div", 7);
    } if (rf & 2) {
        i0.ɵɵadvance(7);
        i0.ɵɵproperty("ngIf", ctx.inputData.getTaskType != "I485" && ctx.formDataArray.common.length == 0);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.inputData == null ? null : ctx.inputData.caseType) != "I130" && !ctx.showDependentVisaPdfGenerateSection);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.subTaskDetails == null ? null : ctx.subTaskDetails.serviceCenterDetails == null ? null : ctx.subTaskDetails.serviceCenterDetails.isPremiumCenter) === 1 && (ctx.inputData == null ? null : ctx.inputData.caseType) != "I130" && ctx.formDataArray.common.length === 0);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.subTaskDetails == null ? null : ctx.subTaskDetails.serviceCenterDetails == null ? null : ctx.subTaskDetails.serviceCenterDetails.isPremiumCenter) === 1 && (ctx.inputData == null ? null : ctx.inputData.caseType) != "I130" && ctx.formDataArray.common.length === 0);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.inputData == null ? null : ctx.inputData.attorneyId) && (ctx.inputData == null ? null : ctx.inputData.caseType) !== "I129EFILING" && (!ctx.showDependentVisaPdfGenerateSection || ((ctx.dependentFormInfo == null ? null : ctx.dependentFormInfo.formDetail) === null || (ctx.dependentFormInfo == null ? null : ctx.dependentFormInfo.formDetail == null ? null : ctx.dependentFormInfo.formDetail.govtAgencyCode) === null || (ctx.dependentFormInfo == null ? null : ctx.dependentFormInfo.formDetail == null ? null : ctx.dependentFormInfo.formDetail.govtAgencyCode) === "USCIS" && ctx.formDataArray.common.length === 0)));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.enotificationAndCCDetails == null ? null : ctx.enotificationAndCCDetails.isAuthCreditCardTrans) === 1);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.enotificationAndCCDetails == null ? null : ctx.enotificationAndCCDetails.isEnotifyReqd) === 1);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.inputData == null ? null : ctx.inputData.caseType) == "I130");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.inputData == null ? null : ctx.inputData.caseType) == "I130" && (ctx.inputData == null ? null : ctx.inputData.filingType) === "e-filing");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.inputData == null ? null : ctx.inputData.caseType) == "I130" && (ctx.inputData == null ? null : ctx.inputData.filingType) === "e-filing" && ctx.showI130InterperterSection);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.inputData == null ? null : ctx.inputData.caseType) == "I130" && ctx.inputData.relationshipCode && ctx.inputData.relationshipCode === "SPOUSE");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showDependentVisaPdfGenerateSection);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.inputData.getTaskType === "I485" || (ctx.dependentFormInfo == null ? null : ctx.dependentFormInfo.generateFormFor));
    } }, directives: [i6.NgIf, i7.OverrideRadioButtonLibraryComponent, i8.OverideUploadFormsLibraryComponent, i9.ButtonDirective, i6.NgForOf], styles: [".form-box[_ngcontent-%COMP%]{border:1px solid #c4c4c4;padding:10px 0;margin-left:15px}.form-box[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{color:#4d4848;font-weight:500;font-size:14px}.form-box[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{font-size:12px;color:#a3a6b4}.step-title[_ngcontent-%COMP%]   h5[_ngcontent-%COMP%]{color:#3d3d63;font:normal normal 700 21px/32px Source Sans Pro}.step-title[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{color:#626262;font:normal normal normal 13px/22px Source Sans Pro}.form-type-title[_ngcontent-%COMP%]{color:#3d3d63;font:normal normal 700 18px/28px Source Sans Pro}.btn-small[_ngcontent-%COMP%]{height:30px!important;border-radius:5px!important}.generateBtnContainer[_ngcontent-%COMP%]{margin-top:25px;width:100%}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GenerateFormsLibraryComponent, [{
        type: Component,
        args: [{
                selector: 'generate-forms-library',
                templateUrl: 'generate-forms-library.component.html',
                styleUrls: ['generate-forms-library.component.scss']
            }]
    }], function () { return [{ type: i1.Store }, { type: i2.ToastrService }, { type: i3.APIGenerateForms }, { type: i4.StepStatusUpdatePayloadService }, { type: i5.ReferenceLibraryService }, { type: i0.ChangeDetectorRef }]; }, { primaryData: [{
            type: Input
        }], formDataArray: [{
            type: Input
        }], onDialogClose: [{
            type: Output
        }], formType: [{
            type: Input
        }], isWizard: [{
            type: Input
        }] }); })();

class GenerateFormsLibraryModule {
}
GenerateFormsLibraryModule.ɵfac = function GenerateFormsLibraryModule_Factory(t) { return new (t || GenerateFormsLibraryModule)(); };
GenerateFormsLibraryModule.ɵmod = i0.ɵɵdefineNgModule({ type: GenerateFormsLibraryModule });
GenerateFormsLibraryModule.ɵinj = i0.ɵɵdefineInjector({ providers: [BaseGenerateFormsLibraryService], imports: [[
            PrimengLibraryModule,
            StepStatusUpdateComponentLibraryModule,
            // DateFormatModule,
            DigitalSignatureLibraryModule,
            OverrideRadioButtonLibraryModule,
            OverideUploadFormsLibraryModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(GenerateFormsLibraryModule, { declarations: [GenerateFormsLibraryComponent], imports: [PrimengLibraryModule,
        StepStatusUpdateComponentLibraryModule,
        // DateFormatModule,
        DigitalSignatureLibraryModule,
        OverrideRadioButtonLibraryModule,
        OverideUploadFormsLibraryModule], exports: [GenerateFormsLibraryComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GenerateFormsLibraryModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    GenerateFormsLibraryComponent,
                ],
                imports: [
                    PrimengLibraryModule,
                    StepStatusUpdateComponentLibraryModule,
                    // DateFormatModule,
                    DigitalSignatureLibraryModule,
                    OverrideRadioButtonLibraryModule,
                    OverideUploadFormsLibraryModule
                ],
                providers: [BaseGenerateFormsLibraryService],
                exports: [GenerateFormsLibraryComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of generate-forms-library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { GenerateFormsLibraryComponent, GenerateFormsLibraryModule, GenerateFormsLibraryService };
//# sourceMappingURL=generate-forms-library.js.map
